export const SETTINGS = '/settings';
export const SETTINGS_ACCOUNT = `${ SETTINGS }/profile`;
export const SETTINGS_ALERTS = `${ SETTINGS }/alerts`;
export const SETTINGS_SECURITY = `${ SETTINGS }/security`;
export const SETTINGS_API = `${ SETTINGS }/api-access`;
export const SETTINGS_NOTIFICATIONS = `${ SETTINGS }/notifications`;
export const SETTINGS_PAYMENTS = `${ SETTINGS }/payments`;
export const SETTINGS_PAYMENTS_SEPA = `${ SETTINGS_PAYMENTS }/sepa`;
export const SETTINGS_HISTORY = `${ SETTINGS }/history`;
